import { action, observable, makeObservable } from 'mobx'

export interface IAnimationObject {
  enabled: boolean
  timeoutId: number
  timeoutMs: number
}

class AnimationStore {
  @observable animationMap = new Map<string, IAnimationObject>()
  
  constructor() {
    makeObservable(this)
  }

  @action
  isAnimating(key: string): boolean {
    const animation = this.animationMap.get(key)
    return animation ? animation.enabled : false
  }

  @action
  register = (key: string, timeoutMs: number): void => {
    this.animationMap.set(key, {
      enabled: false,
      timeoutId: 0,
      timeoutMs
    })
  }

  @action
  start = (key: string): void => {
    const animation = this.animationMap.get(key)
    if (animation) {
      let { timeoutId } = animation

      if (timeoutId) {
        window.clearTimeout(timeoutId)
        this.animationMap.set(key, { ...animation, enabled: false })
      }

      timeoutId = window.setTimeout(() => this.animationMap.set(key, { ...animation, enabled: false }), animation.timeoutMs)

      window.requestAnimationFrame(() => {
        this.animationMap.set(key, {
          ...animation,
          enabled: true,
          timeoutId
        })
      })
    }
  }
}

export const animationStore = new AnimationStore()
